<template>
  <div>
    <el-dialog title="Select Employee" width="50%" v-model="modal.employee.visible" :close-on-click-modal="false"
      append-to-body>
      <el-input v-model="query.keyword" placeholder="Search employee name" clearable style="margin-bottom: 20px"
        @input="handleSearch" />
      <el-table :data="list" stripe v-loading="loading" @row-click="handleSelect" header-cell-class-name="my-header">
        <el-table-column prop="name" label="Employee Name" />
      </el-table>
      <PaginationBar :query="query" :total="total" @change="getList" />
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { debounce } from 'lodash'
import { fetchUserList as fetchEmployeeList } from '@/api/login'
import { useModalStore } from '@/stores/modal'
import { useList } from '@/composables/useList'
import { defaultEmployeeListQuery as defaultListQuery } from './defaults'
import PaginationBar from './PaginationBar.vue'

const modal = useModalStore()

const { list, loading, total, query, getList } = useList(fetchEmployeeList, { ...defaultListQuery })

const handleSearch = debounce(() => {
  query.pageNum = 1
  getList()
}, 300)

function handleSelect(row) {
  modal.resolveEmployee(row)
}

onMounted(getList)
</script>

<style scoped>
.my-header {
  font-weight: bold;
}
</style>
